import type { WalletTopUpsTranslations } from "../interfaces/walletTopUps";

export const walletTopUpsTranslations: WalletTopUpsTranslations = {
  page_title: "Recargas de carteiras",
  page_subtitle:
    "Credite fundos da Coloca na carteira de um cliente. Cada recarga pede o seu código de verificação, fica registrada e o cliente recebe o comprovante.",
  action_refresh: "Atualizar o histórico",
  action_new: "Nova recarga",
  action_retry: "Tentar novamente",
  filter_organization: "Organização",
  filter_all_option: "Todas as organizações",
  filter_all_hint: "Mostrando as recargas de todas as organizações.",
  filter_org_hint: "Mostrando apenas as recargas desta organização.",

  empty_title: "Ainda não há recargas",
  empty_description: "As recargas que você fizer aparecem aqui com o comprovante.",
  col_date: "Data",
  col_organization: "Organização",
  col_amount: "Valor",
  col_concept: "Conceito e nota interna",
  col_reference: "Referência",
  col_by: "Feita por",
  col_receipt: "Comprovante",
  card_note: "Nota interna: {{note}}",
  card_by: "Feita por {{email}}",

  dialog_title: "Recarregar uma carteira",
  dialog_title_review: "Revise a recarga",
  dialog_title_done: "Recarga creditada",
  dialog_title_processing: "Creditando a recarga…",
  dialog_description: "O saldo sai dos fundos da Coloca e fica disponível para o cliente na hora.",
  dialog_description_review: "Confira a organização, a carteira e o valor antes de autorizar.",
  dialog_description_done: "O cliente já vê a recarga no extrato.",
  dialog_description_processing:
    "Estamos creditando o saldo e enviando o comprovante por e-mail; pode levar alguns segundos. Não feche esta janela.",
  processing_from: "Coloca Payments",
  processing_transit_aria:
    "{{amount}} {{currency}} a caminho da Coloca Payments para a carteira {{currency}} de {{name}}.",
  action_cancel: "Cancelar",
  action_review: "Revisar recarga",
  action_back: "Voltar",
  action_confirm: "Autorizar recarga",
  action_another: "Fazer outra recarga",
  action_close: "Fechar",

  field_organization: "Organização",
  field_organization_required_hint: "Escolha a organização que recebe a recarga.",
  field_organization_hint: "A recarga é creditada em uma carteira desta organização.",
  organization_unknown: "a organização",
  field_wallet: "Carteira",
  field_wallet_hint: "A moeda da carteira é a moeda da recarga.",
  field_wallet_placeholder: "Escolha uma carteira",
  field_wallet_none: "Esta organização não tem carteiras ativadas. Ative uma em Carteiras e tente novamente.",
  field_wallet_option: "{{currency}} · saldo {{balance}}",
  field_wallet_option_inactive: "{{currency}} · {{status}}",
  wallet_frozen: "congelada",
  wallet_closed: "fechada",
  field_amount: "Valor",
  field_amount_hint: "Em {{currency}}. É somado ao saldo disponível.",
  field_concept: "Conceito",
  field_concept_hint: "O cliente vê no extrato, no e-mail e no comprovante.",
  concept_default: "Recarga de saldo",
  field_note: "Nota interna",
  field_note_hint: "Só a equipe da Coloca vê: por que é creditado e onde estão os fundos.",
  field_note_placeholder: "Ex.: fundos já recebidos no provedor, solicitação de suporte #482",

  validation_wallet: "Escolha a carteira que recebe a recarga.",
  validation_amount: "Digite um valor maior que zero.",
  validation_amount_precision: "{{currency}} aceita no máximo {{digits}} casas decimais.",
  validation_concept: "Digite o conceito que o cliente verá.",
  validation_note: "Digite uma nota interna para o registro.",

  review_organization: "Organização",
  review_wallet: "Carteira",
  review_wallet_value: "Carteira {{currency}}",
  review_balance_before: "Saldo disponível agora",
  review_amount: "Recarga da Coloca Payments",
  review_balance_after: "Saldo depois da recarga",
  review_concept: "Conceito (o cliente vê)",
  review_note: "Nota interna",
  review_client_sees:
    "O cliente verá como uma recarga da Coloca Payments e receberá o comprovante por e-mail. Você também recebe uma cópia.",
  review_irreversible: "A recarga é imediata e não pode ser desfeita pelo painel.",
  review_checkbox: "Conferi a organização, a carteira e o valor",

  two_factor_required:
    "Para recarregar carteiras você precisa da verificação em duas etapas ativa. Ative-a em Configurações e volte.",
  two_factor_description: "Você vai creditar {{amount}} {{currency}} para {{name}}.",

  unresolved_title: "Uma recarga ficou sem confirmação",
  unresolved_text:
    "Uma recarga de {{amount}} (“{{concept}}”) para esta organização foi autorizada e a resposta não chegou, então não sabemos se foi creditada. Verifique antes de fazer outra.",
  unresolved_text_retry:
    "A resposta não chegou, então não sabemos se esta recarga foi creditada. Verifique, ou autorize de novo: se ela já tinha sido feita, não é creditada duas vezes.",
  unresolved_action: "Verificar a recarga",
  unresolved_pending: "Ainda está sendo processada. Verifique de novo em alguns segundos.",
  unresolved_unknown: "Não conseguimos verificar. Tente de novo em instantes.",
  unresolved_not_placed: "A recarga sem confirmação não foi creditada. Você já pode fazer a recarga.",
  top_up_busy:
    "Outra aba está enviando uma recarga para esta organização. Espere terminar e autorize de novo; nada foi enviado.",
  unresolved_blocked: "Há uma recarga para esta organização sem confirmação. Verifique antes de fazer outra.",

  done_recovered:
    "A recarga sem confirmação foi creditada. Este é o comprovante; a verificação não creditou nada de novo.",
  done_replayed:
    "Esta recarga já tinha sido feita com os mesmos dados. Nada foi creditado de novo e nenhum e-mail foi enviado.",
  done_receipt_label: "Comprovante de recarga",
  done_credited: "Creditado",
  done_amount: "Valor creditado",
  done_beneficiary: "Beneficiário",
  done_wallet: "Carteira",
  done_concept: "Conceito",
  done_origin: "Origem",
  done_emails_label: "E-mails enviados",
  email_pending: "Estamos enviando o comprovante {{who}}.",
  email_sent: "Enviamos o comprovante {{who}}.",
  email_failed: "Não conseguimos enviar o e-mail {{who}}. Baixe o comprovante e compartilhe.",
  email_no_address: "Não enviamos e-mail {{who}}: não há e-mail cadastrado.",
  email_to_operator: "para o seu e-mail",
  email_to_accounting: "para o e-mail da contabilidade",
  email_to_organization: "para a organização",

  receipt_download: "Baixar comprovante",
  receipt_download_for: "Baixar o comprovante {{reference}}",
  receipt_share: "Compartilhar",
  receipt_share_title: "Comprovante de recarga {{reference}}",
  receipt_error: "Não conseguimos obter o comprovante: {{message}}",
  kind_incident_refund: "Reembolso",
  done_receipt_label_refund: "Comprovante de reembolso",
};
